
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { TimezoneApi } from '../../../shared/nestjs/gd-only/services/timezone.api';
import { ResponseGetTimezone, RequestUpdateTimezoneDto } from '../../../shared/nestjs/gd-only/dto/timezone.dto';
import { ResponseData } from '../../../shared/nestjs/nest-responses';

@Injectable()
export class SettingTimezonenBloc {
  private subscriptions: Array<Subscription> = [];
  constructor(
    public timezoneApi: TimezoneApi,
  ) {

  }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  getAllTimezone() {
    return new Promise<ResponseGetTimezone[]>((resolve, reject) => {
      this.subscriptions.push(
        this.timezoneApi.getAllTimezone()
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }

  updateTimezoneEmployees(payload: RequestUpdateTimezoneDto) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.timezoneApi.updateTimezoneEmployees(payload)
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }

  getTimezoneHistory() {
    return new Promise<ResponseData<any>>((resolve, reject) => {
      this.subscriptions.push(
        this.timezoneApi.getTimezoneHistory()
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }
}




// WEBPACK FOOTER //
// ./src/bloc/settings/employee-setup/setting-timezone.bloc.ts